<apx-chart *ngIf="hasData; else emptyChart" [series]="series" [chart]="chart" [labels]="chartLabels"
  [colors]="chartColors" [plotOptions]="plotOptions" [legend]="legend" [dataLabels]="dataLabels" [tooltip]="tooltip"
  [states]="states">
</apx-chart>

<ng-template #emptyChart>
  <div class="empty-chart" [style.height.px]="height">
    <i class="pi pi-info-circle text-primary mb-3" style="font-size: 2rem"></i>
    <p class="m-0 text-secondary fs-6">No hay datos disponibles</p>
  </div>
</ng-template>
